<template>
  <div class="py-6 px-4 md:p-6 surface1">
    <div class="flex justify-between items-center mb-4">
      <h4 class="headline-5 py-2">Nuevo idioma</h4>
      <ButtonIcon icon="close" class="btn-text-link" @click="$emit('close')" />
    </div>
    <form @submit.prevent="emitForm">
      <FormSelect
        id="language_id"
        v-model="language_id"
        label="Idioma"
        :required="true"
        :error="errors.language_id"
      >
        <option value="" disabled>Seleccionar</option>
        <option v-for="option in language_options" :key="option.id" :value="option.id">
          {{ option.name }}
        </option>
      </FormSelect>
      <FormSelect
        id="language_proficiency_level_id"
        v-model="language_proficiency_level_id"
        label="Nivel de competencia"
        hint="Selecciona tu grado de competencia lingüística en el idioma"
        :required="true"
        :error="errors.language_proficiency_level_id"
      >
        <option value="" disabled>Seleccionar</option>
        <option v-for="option in language_proficiency_options" :key="option.id" :value="option.id">
          {{ option.name }}
        </option>
      </FormSelect>
      <div class="mt-3 text-center">
        <Button type="submit" class="btn-filled">
          Guardar
        </Button>
        <Button class="btn-tonal" @click="$emit('close')">
          Descartar
        </Button>
      </div>
    </form>
  </div>
</template>

<script>
import Button from '@/Components/Button'
import FormInputText from '@/Components/FormInputText'
import FormTextarea from '@/Components/FormTextarea'
import FormSelect from '@/Components/FormSelect'
import ButtonIcon from '@/Components/ButtonIcon'

export default {
  name: 'LanguageForm',
  components: {
    Button,
    FormInputText,
    FormTextarea,
    FormSelect,
    ButtonIcon,
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
    previousForm: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
    language_options: {
      type: Array,
      required: true,
    },
    language_proficiency_options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      language_id: this.previousForm.language_id,
      language_proficiency_level_id: this.previousForm.language_proficiency_level_id,
    }
  },
  methods: {
    emitForm() {
      let language_id = this.language_id,
        language_proficiency_level_id = this.language_proficiency_level_id

      this.$emit('emit-record', {
        language_id,
        language_proficiency_level_id,
        language_name: this.language_options.find(item => {
          console.log(item.id, language_id, item.id == language_id)
          return item.id == language_id
        }).name,
        language_proficiency_level_name: this.language_proficiency_options.find(
          item => item.id == language_proficiency_level_id,
        ).name,
      })
    },
  },
}
</script>
